
export const getBaseUrl = () => {

    const baseUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");

    return baseUrl;

};

export default getBaseUrl;